export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6097.d2685c1d.jpg";